
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-quizz',
  components: { CustomWrapper }
})
export default class CQuizz extends Vue {

  @Prop({ default: 'div'}) tag!: string

}
